module.exports = __webpack_public_path__ + "static/media/marc.2372e8d3.jpeg";